/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 連携活動その他1
 */
export type BaseInfoCollaborationOther1Enum =
  (typeof BaseInfoCollaborationOther1Enum)[keyof typeof BaseInfoCollaborationOther1Enum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseInfoCollaborationOther1Enum = {
  PUMP: 'PUMP',
  RESCUE_TEAM: 'RESCUE_TEAM',
  PUMP_AND_RESCUE_TEAM: 'PUMP_AND_RESCUE_TEAM',
  DR_HELI: 'DR_HELI',
  DISASTER_DR_HELI: 'DISASTER_DR_HELI',
  DR_CAR: 'DR_CAR',
  OTHER_EMS_TEAM: 'OTHER_EMS_TEAM',
  OTHER: 'OTHER',
} as const;
